import "./App.css";
import { useState, useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import HomePage from "./Components/PresentationComponents/Home.jsx";
import MainLayout from "./Components/PresentationComponents/MainLayout.jsx";
import Services from "./Components/PresentationComponents/Services.jsx";
import Projects from "./Components/PresentationComponents/Projects.jsx";
// import About from './Components/PresentationComponents/About.jsx';
import Contact from "./Components/PresentationComponents/Contact.jsx";
import ServiceDetails from "./Components/PresentationComponents/Serviceviewpage.jsx";
import ProjectDetails from "./Components/PresentationComponents/Projectviewpage.jsx";

import { ThemeProvider } from "./Components/PresentationComponents/ThemeProvider.jsx";
import LoadingScreen from "./Components/PresentationComponents/LoadingScreen.jsx";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <MainLayout />,
      children: [
        { path: "", element: <HomePage /> },
        { path: "services", element: <Services /> },
        { path: "projects", element: <Projects /> },
        { path: "servicesview/:id", element: <ServiceDetails /> },
        { path: "projectsview/:id", element: <ProjectDetails /> },
        // { path: "about", element: <About /> },
        { path: "contact", element: <Contact /> },
      ],
    },
  ]);

  useEffect(() => {
    // Ensure loading screen shows for at least animation duration
    const timer = setTimeout(() => setIsLoading(false), 2400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <ThemeProvider>
      {isLoading ? (
        <LoadingScreen onFinished={() => setIsLoading(false)} />
      ) : (
        <RouterProvider router={router} />
      )}
    </ThemeProvider>
  );
}

export default App;

